import * as types from './mutation-types'

const state = {
  openItems: JSON.parse(localStorage.getItem('tree-state')) || [],
}

const getters = {
  openItems(state) {
    return state.openItems
  },
}

const actions = {
  toggleTreeItem({ commit }, item) {
    commit(types.TOGGLE_TREE_ITEM, { item })
  },
}

const mutations = {
  [types.TOGGLE_TREE_ITEM](state, { item }) {
    const index = state.openItems.indexOf(item)
    if (index > -1) {
      state.openItems.splice(index, 1)
    } else {
      state.openItems.push(item)
    }
    localStorage.setItem('tree-state', JSON.stringify(state.openItems))
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
